import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'
import preventEvents from '../../../utils/preventEvents'
import OldDashboard from '../Common/Dashboard'
import Parameters from '../Common/Parameters'
import Version from '../Common/Version'
import Dashboard from '../../Menus/Mobile/Dashboard'
import TemplateGlobal from '../../Templates/TemplateGlobal'
import { TemplateTarget } from '../../../models/enums'

interface ParametersAndDashboardContainerProps {
  handleBack: () => void
  hideMenu: boolean
}

const ParametersAndDashboardContainer = ({ handleBack, hideMenu = false }: ParametersAndDashboardContainerProps): JSX.Element => {
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const locale = useSelector((state: RootState) => state.localeReducer.locale)
  const menu = useSelector((state: RootState) => state.retorikReducer.configuration.menu)
  const isWidget = useSelector((state: RootState) => state.viewReducer.isWidget)
  const divRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    divRef?.current && isWidget && preventEvents(null, divRef)
  }, [divRef.current])

  return (
    <TemplateGlobal onClick={handleBack} target={TemplateTarget.mobileOther}>
      <div ref={divRef} className='rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden rf-pointer-events-auto'>
        {/* Dashboard */}
        {!hideMenu && (
          <React.Fragment>
            {menu?.categories?.length ? <Dashboard toggleDashboard={handleBack} /> : <OldDashboard toggleDashboard={handleBack} />}
            <div className='rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder' />
          </React.Fragment>
        )}

        {/* Parameters container */}
        <div className='rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start'>
          {/* Title */}
          <div className='rf-py-4 rf-text-lightgray'>{capitalizeFirstLetter(translation.common.parameters, locale)}</div>

          {/* Parameters */}
          <Parameters handleBack={handleBack} />
        </div>

        <Version isMobile />
      </div>
    </TemplateGlobal>
  )
}

export default ParametersAndDashboardContainer
